import { FileText } from "lucide-react";
import "./index.css";
export default function CommissionStructure() {
  return (
    <div className="comm-struc-container">
      {/* Header Section */}
      <div className="comm-struc-header">
        <h1 className="comm-struc-title">Commission Structure</h1>
        <p className="comm-struc-description">
          Stay informed about our transparent commission structure, fees, and
          applicable taxes.
        </p>
      </div>

      {/* Commission Table */}
      <div className="comm-struc-table-container">
        <h2 className="comm-struc-subtitle">
          <FileText className="comm-struc-icon" /> Commission & Charges
        </h2>
        <table className="comm-struc-table">
          <thead>
            <tr>
              <th className="color-white">Share Price (PKR)</th>
              <th className="color-white">Commission (PKR)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0.01 – 20.0</td>
              <td>0.03/Share</td>
            </tr>
            <tr>
              <td>20.00 - 40.00</td>
              <td>0.06/Share</td>
            </tr>
            <tr>
              <td>40.00 & Above</td>
              <td>0.15% of Share Value (whichever is higher)</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Features & Value Added Services */}
      <div className="comm-struc-table-container">
        <h2 className="comm-struc-subtitle">
          <FileText className="comm-struc-icon" /> Features & Value Added
          Services
        </h2>
        <table className="comm-struc-table">
          <thead>
            <tr>
              <th className="color-white">Feature</th>
              <th className="color-white">Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Minimum cash required for Account Opening</td>
              <td>Rs. 5,000</td>
            </tr>
            <tr>
              <td>
                Minimum Equity Required for Account Opening (Cash + Stocks)
              </td>
              <td>Rs. 25,000</td>
            </tr>
            <tr>
              <td>Requirement of Advance Cash/Margins (Ready)</td>
              <td>100%</td>
            </tr>
            <tr>
              <td>Leverage Trading (Future)</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Leverage Trading (MFS)</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Leverage Trading (MTS)</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Margin Requirements for Leverage Trading (Future)</td>
              <td>25%</td>
            </tr>
            <tr>
              <td>Margin Requirements for Leverage Trading (MFS)</td>
              <td>25%</td>
            </tr>
            <tr>
              <td>Margin Requirements for Leverage Trading (MTS)</td>
              <td>15%</td>
            </tr>
            <tr>
              <td>Equity Trader Facility</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Trading Terminal Facility</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Email Research Reports</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Online Funds Transfer Facility</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Execution of Trade through KATS</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>
                Execution of Sale trade without shares held in CDC Sub Account<br/>
                but available in CDC Investor Account or with any other
                participant/TREC holder
              </td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>One side commission applied on day trades</td>
              <td>Yes</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Corporate Fees Table */}
      <div className="comm-struc-table-container">
        <h2 className="comm-struc-subtitle">
          <FileText className="comm-struc-icon" /> Corporate Fees & Taxes
        </h2>
        <table className="comm-struc-table">
          <thead>
            <tr className="">
              <th className="color-white">Corporate Fees & Charges</th>
              <th className="color-white">Taxes & Charges (PKR)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="">Sindh Sales Tax (SST)</td>
              <td className="">13% of Commission</td>
            </tr>
            <tr>
              <td>UIN Maintenance</td>
              <td>RS. 200/= (Per Annum)</td>
            </tr>
            <tr>
              <td>CDC Maintenance</td>
              <td>RS. 400/= (Per Annum)</td>
            </tr>
            <tr>
              <td>CDC Handling</td>
              <td>RS. 0.005 per share (On Delivery Sale/Purchase)</td>
            </tr>
            <tr>
              <td>Weekly Commission on Future Rollover</td>
              <td>As per actual</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Important Notes */}
      <div className="comm-struc-notes">
        <h3>Important Notes:</h3>
        <ul>
          <li>
            Weekly Rollover Commission will be charged on future market and
            leverage positions.
          </li>
          <li>
            Mark to Market Losses will be collected from clients on a daily
            basis.
          </li>
          <li>
            CDC & NCCPL charges shall be applicable as per the CDC & NCCPL
            Regulations.
          </li>
          <li>
            Transaction fees, Government taxes, or any other applicable charges
            shall be billed to the client.
          </li>
          <li>
            OSPL reserves the right to revise the Commission Structure as deemed
            appropriate.
          </li>
        </ul>
      </div>
    </div>
  );
}
